import { styled } from '@volkswagen-onehub/components-core';
import { css } from 'styled-components';


type DesktopContainerProps = {
  numberOfOffers: number;
  isOverview: boolean;
  useMaxWidth?: boolean;

};
  
export const DesktopOfferContainer = styled.div<DesktopContainerProps>`
  max-width: ${(props)=>( props.useMaxWidth ? '1920px' : null)};
  margin: 0 auto;
  position: relative;
  ${(props) =>
    props.isOverview &&
    css`
      padding-top: 48px;
      padding-bottom: 132px;
      @media screen and (min-width: 1600px) {
        padding-bottom: 196px;
      }
      &.last-row {
        padding-bottom: 0;
      }
      &.offers-enter {
        transform: translate(0, -20%);
        opacity: 0.01;
        display: block;
      }
      &.offers-enter-active {
        transform: translate(0, 0);
        opacity: 1;
        transition: transform 300ms, opacity 500ms ease-in;
        display: block;
      }
      &.offers-enter-done {
        display: block;
      }
      &.offers-exit {
        transform: translate(0, 0);
        opacity: 1;
        display: block;
      }
      &.offers-exit-active {
        transform: translate(0, -100%);
        opacity: 0.01;
        transition: all 300ms, opacity 500ms ease-in;
        display: block;
      }
  `}
`;
